import _ from 'underscore';
import {
  TargetingSettingsContext,
  TargetingType,
  getFilterStateConfig
} from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { crossPageSelectAllPlugin } from '@bingads-webui/projection-grid-cross-page-select-all';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';
import { toolbarPlugin } from '@bingads-webui/projection-grid-toolbar';

const getQuickFilterConfig = () => {
  const recommendationFilterItem = {
    key: 'recommendation',
    text: TargetingSettingsContext.i18n.getString('Filter_Recommendation'),
    value: {
      query: {
        RecommendationTypes: {
          $eq: 'NewTargets',
        },
      },
    },
    classes: 'quick-filter-all-recommendation',
  };
  const quickFilter = {
    items: [{
      key: 'all',
      text: TargetingSettingsContext.i18n.getString('Dashboard_AllCampaigns'),
      value: {
        query: {},
      },
      classes: 'quick-filter-all',
    }, {
      key: 'active',
      text: TargetingSettingsContext.i18n.getString('Dashboard_AllEnabledCampaigns'),
      value: {
        query: {
          Status: {
            $in: [
              'Enum.CampaignStatus\'Active\'',
              'Enum.CampaignStatus\'BudgetPaused\'',
            ],
          },
        },
      },
      classes: 'quick-filter-all-active',
    }].concat([recommendationFilterItem]),
  };
  return quickFilter;
};

const getLowerToolbarConfig = () => ({
  items: [{
    type: 'button',
    text: TargetingSettingsContext.i18n.getString('Grid_CreateCampaignButtonText'),
    classes: ['btn', 'btn-primary'],
    onClick: () => {
      TargetingSettingsContext.router.navigateToRoute('campaign_create_objective');
    },
    disabled: TargetingSettingsContext.pageContext.Permissions.IsReadOnlyUser
      || TargetingSettingsContext.config.get('CurrentAccountInActive'),
  }, {
    type: 'dropdown',
    id: 'dropdown-edit',
    disabled: TargetingSettingsContext.pageContext.Permissions.IsReadOnlyUser
      || TargetingSettingsContext.config.get('CurrentAccountInActive'),
  }, {
    type: 'selector',
    id: 'quick-filter',
  }, {
    type: 'dropdown',
    id: 'dropdown-column-chooser',
  }],
});

export const getAdditionalPlugins = view => [
  {
    plugin: crossPageSelectAllPlugin,
    config: {
      i18n: TargetingSettingsContext.i18n,
    },
  }, {
    plugin: placeholderPlugin,
    config: {
      viewRoot: view.$el,
      container: '.noresult-container',
      text: TargetingSettingsContext.i18n.getString('Grid_NoRecords'),
      filteredContainer: '.noresult-container',
      filteredEmptyText: TargetingSettingsContext.i18n.getString('Grid_NoFilteredRecords'),
    },
  }, {
    plugin: toolbarPlugin,
    config: {
      'lower-toolbar': getLowerToolbarConfig(),
    },
  }, {
    plugin: TargetingSettingsContext.quickFilterPlugin,
    config: getQuickFilterConfig(),
  }, {
    plugin: TargetingSettingsContext.filterStatePlugin,
    config: _.defaults({
      container: view.$('.filter-bar'),
    }, getFilterStateConfig({ setting: TargetingType.AllSettings })),
  },
];
